import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { ActivatedRoute } from '@angular/router';


export interface Usuarios {
  Nombre: string;
  Email: string;
  IdTipo: string;
  Estado: number;
  Id:number;
  Validado: number;
}



@Component({
  selector: 'app-tabla-usuarios',
  templateUrl: './tabla-usuarios.component.html',
  styleUrls: ['./tabla-usuarios.component.scss'],
})
export class TablaUsuariosComponent implements OnInit {

  displayedColumns: string[] = ['select', 'Nombre', 'Email', 'Roles', 'Estado', 'Validado'];
  dataSource: MatTableDataSource<Usuarios>;
  selection = new SelectionModel<Usuarios>(true, []);

  filtro = "todos";
  TiposUsuarios = []
  Datos = []
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  valval="todos"

  constructor(private conexion: ConexionService, public utilidades: UtilidadesService, private activated: ActivatedRoute) {
    this.dataSource = new MatTableDataSource([])
  }

  ngOnInit() { 
    this.getTiposUsuarios()
    setTimeout(() => {
      this.getUsuarios()
    }, 250);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  FiltroPorValidado(val){
    let c = JSON.stringify(this.Datos)
    let cj: any[] = JSON.parse(c)
    let u = []
    if(val!= "todos"){
      u = cj.filter(user => user.Validado==val)
    }else{
      u = cj
    }

    this.dataSource = new MatTableDataSource(u);
    this.ngAfterViewInit()
    this.valval=val
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  getUsuarios() {
    this.utilidades.Loading("Cargando usuarios")
    this.conexion.getUsuarios(this.filtro).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(resp, "console", "")
      if (resp.Respuesta == "Exito") {
        this.Datos = resp.Datos
        this.dataSource = new MatTableDataSource(resp.Datos);
        this.ngAfterViewInit()
        this.FiltroPorValidado(this.valval)
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  getTiposUsuarios() {
    this.conexion.getTiposUsuarios().subscribe((resp) => {
      if (resp.Respuesta == "Exito") {
        this.TiposUsuarios=(resp.Datos);
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


  CambiarRolUsuario(row) {
    this.utilidades.Loading("Cambiando rol del usuario")
    this.conexion.CambiarRolUsuario(row.Id, row.Roles).subscribe((resp) => {
      this.utilidades.CerrarLoading()
     this.utilidades.Toast(resp.Mensaje)
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  CambiarEstado(Estado) {
    this.utilidades.Loading("Cambiando estado de los usuarios")
    let datos = {Usuarios: this.selection.selected, Estado}
    this.conexion.CambiarEstadoUsuario(datos).subscribe((resp) => {
      this.getUsuarios()
      this.utilidades.CerrarLoading()
     this.utilidades.Toast(resp.Mensaje)
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  ReenviarCorreoActivacion() {
    let datos = {Usuarios: this.selection.selected}
    let ban = false
    for(let i of datos.Usuarios){
      if (i.Validado){
        this.selection.deselect(i)
        ban=true
      }
    }

    datos = {Usuarios: this.selection.selected}
    if(ban) this.utilidades.Toast("Los usuarios ya validados fueron desmarcados. Cantidad de usuarios a los que se enviará el mensaje: " + datos.Usuarios.length)

    if(this.selection.selected.length==0) return 0;
    
    this.utilidades.Loading("Cambiando estado de los usuarios")
    this.conexion.ReenviarCorreoActivacion(datos).subscribe((resp) => {
      this.getUsuarios()
      this.utilidades.CerrarLoading()
     this.utilidades.Toast(resp.Mensaje)
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }
}
